export default "__VITE_ASSET__xxWtfz50__"